import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {SeFeCardModule} from 'se-fe-card';
import {SeFeEmptyStateModule} from 'se-fe-empty-state';
import {SeFeGridModule} from 'se-fe-grid';
import {SeFeHeaderModule} from 'se-fe-header';
import {SeFePageModule} from 'se-fe-page';
import {NotFoundException} from './exceptions/not-found.exception';

/**
 * Component for displaying error messages.
 * @Component
 */
@Component({
  selector: 'se-error',
  templateUrl: './error.component.html',
  styleUrl: 'error.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SeFeCardModule, SeFeEmptyStateModule, SeFeGridModule, SeFeHeaderModule, SeFePageModule],
})
export class ErrorComponent {
  message = 'Unknown error.';
  code = 'PM-0000';
  constructor(private router: Router) {
    const nav = this.router.currentNavigation();
    const error = nav?.extras?.state?.['error'] ?? new NotFoundException();
    this.message = error.message;
    this.code = error.code;
  }
}
